const state = {
    tableItems: [],
    menuItems: [],
    optionSelect: { id: '1_1', text: 'usuarios', type: 'grid' },
    currentPage: 1,
    mobile: null,
    showPopup: false,
    activeForm: '',
    //ToDo: donde se utiliza el state "activeEl"
    activeEl: null
};

export default state;